<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>Controller</strong>
  <mat-icon (click)="onNoClick(false)">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<form [formGroup]="controllerForm" (ngSubmit)="onSubmit()">
  <mat-form-field fxFill appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name" />
  </mat-form-field>
  <mat-form-field fxFill appearance="fill">
    <mat-label>Regex</mat-label>
    <input matInput id="regex" formControlName="regex" type="text" placeholder="Enter the regex" />
  </mat-form-field>
  <div class="sqlQuery">
    <mat-form-field fxFill appearance="fill">
      <mat-label>List of Values</mat-label>
      <mat-chip-grid #chipList aria-label="Fruit selection">
        @for (fruit of values; track fruit.name) {
        <mat-chip (removed)="remove(fruit)">
          {{ fruit.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        }
        <input
          formControlName="listOfValues"
          placeholder="New value..."
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
        />
      </mat-chip-grid>
    </mat-form-field>
  </div>
  <div class="sqlQuery">
    <mat-form-field fxFill appearance="fill">
      <mat-label>Sql Query</mat-label>
      <textarea matInput formControlName="sqlQuery" placeholder="Ex. SELECT * from TOTO  Where ... "></textarea>
      <mat-hint style="cursor: pointer" (click)="onCheckRequete()">Test query</mat-hint>
    </mat-form-field>
  </div>
  @if (error !== '') {
  <span style="text-align: center"> {{ error }}</span>
  }
  <br />
  <mat-divider class="divider"></mat-divider>

  <div mat-dialog-actions class="btn-container">
    @if (data !== null) {
    <button type="submit" mat-raised-button color="warn">Update</button>
    } @else {
    <button type="submit" mat-raised-button color="primary">Submit</button>
    }
  </div>
</form>
